import Reveal from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    t: "Type the name",
    d: "A person or a business — first, middle and last, exactly as the court expects it. Or paste a case number if you have one.",
  },
  {
    n: "02",
    t: "We open the court",
    d: "The official NYSCEF search launches in a new tab with your details on the clipboard, ready to paste. A quick security check is the court's own.",
  },
  {
    n: "03",
    t: "Review the docket",
    d: "Scan filings, judgments and appearances — every county in New York State, straight from the source.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="scroll-mt-24 px-5 py-24 md:px-8 md:py-32" data-testid="how-it-works">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="mb-4 text-[11px] font-bold uppercase tracking-[0.22em] text-crimson">How it works</p>
          <h2 className="max-w-xl font-display text-4xl leading-[1.1] tracking-tight text-ink md:text-5xl">
            From name to docket, in three moves.
          </h2>
        </Reveal>
        <div className="mt-14 grid border-t border-hairline md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12} className="border-b border-hairline md:border-b-0 md:pr-10 md:last:pr-0">
              <div className="border-hairline py-10 md:border-l md:pl-10 md:first:border-l-0 md:first:pl-0">
                <p className="font-display text-6xl text-crimson/25">{s.n}</p>
                <h3 className="mt-6 font-display text-2xl text-ink">{s.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-smoke">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
